import React,{Children, FC,ReactNode} from 'react'

interface Props {
    children:ReactNode
}

export const TableActionWrapper:FC<Props> = ({children}) => {
  return (
    <div className="d-flex align-items-center gap-3" >
         {children}
    </div>
  )
}


